<div style="background-color: #F5F7F8; height: 100vh; overflow-y: scroll; padding: 10px;">
    <img style="width: 22px; height: 22px; position: relative; top: 10px; left: 10px;" (click)="this.back()" src="/assets/images/shared/back.svg">
    <img style="width: 65px; height: 65px; border-radius: 30px; margin: auto; display: block; margin-top: 20px;" [src]="this.partnerImage" alt="">
    <h3 style="text-align: center; font-weight: bold; margin-top: 20px;">{{this.partner?.data?.name_in_latin}}</h3>

    <div style="width: 90%; margin: auto; background-color: white; margin-top: 20px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">Работно време</p>
        <div>
            <span style="width: 60%;">{{this.labels.shared.monday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.monday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.tuesday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.tuesday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.wednesday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.wednesday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.thursday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.thursday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.friday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.friday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.saturday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.saturday[0]}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.labels.shared.sunday}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.workingTime.sunday[0]}}</span>
        </div>
    </div>

    <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="font-weight: bold; width: 80%; display: inline-block;">{{this.pageDetails().sellerInfo}}</p>
        <div>
            <span style="width: 60%;">Фирма:</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.partner?.data?.native_name + ' ' + this.partner?.data?.legal_form?.label}}</span>
        </div>
        <div>
            <span style="width: 60%;">ЕИК / Булстат:</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.partner?.data?.number}}</span>
        </div>
        <div>
            <span style="width: 60%;">ДДС №:</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.partner?.data?.vat_number || '-'}}</span>
        </div>
        <div>
            <span style="width: 60%;">{{this.pageDetails().phone}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.partner?.data?.contact?.mobile_phone_1_e164}}</span>
        </div>
        <div>
            <span style="width: 60%; vertical-align: top;">{{this.pageDetails().address}}</span>
            <span style="width: 35%; font-weight: bold; margin: 5px;">{{this.partnerLocation}}</span>
        </div>
    </div>

    <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;">
        <p style="display: inline-block; font-weight: bold;" role="button" aria-expanded="false" aria-controls="collapseExample">Бизнес:</p>
        <div (click)="this.isDescrExpanded = !this.isDescrExpanded" *ngIf="this.partner && this.partner!.data.description && this.partner!.data.description.length > 250"  [@slideInOut]="this.isDescExpandedAnimationString" id="descr">
            {{ this.partner?.data?.description }}
        </div>
        <div (click)="this.isDescrExpanded = !this.isDescrExpanded" *ngIf="this.partner && this.partner!.data.description && this.partner!.data.description.length < 250" style="margin-top: 10px; overflow: hidden" id="descr">
            {{ this.partner?.data?.description }}
        </div>
        <div  *ngIf="this.partner && this.partner!.data.description && this.partner!.data.description.length > 250" style="text-align: center;">
            <img (click)="this.isDescrExpanded = !this.isDescrExpanded" [style]="this.isDescrExpanded ? 'width: 15px; height: 15px; display: inline-block; transform: rotate(-90deg)' : 'width: 15px; height: 15px; display: inline-block; transform: rotate(90deg);'" src="/assets/images/product/arrow.svg" alt="">
        </div>

    </div>

    <div style="width: 90%; margin: auto; background-color: white; margin-top: 10px; border-radius: 10px; padding: 10px;" >
        <div (click)="this.openDocument(files.WARRANTY)" style="margin-top: 7px;">
            <div style="margin-top: 7px;">
                <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px;" src="/assets/images/documents/icon-terms.svg" alt="">
                <p style="display: inline-block; font-weight:500;">{{ this.pageDetails().warranty }}</p>
            </div>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <div (click)="this.openDocument(files.RETURNS)" style="margin-top: 7px;">
            <div style="margin-top: 7px;">
                <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px;" src="/assets/images/documents/icon-legal.svg" alt="">
                <p style="display: inline-block; font-weight:500;">{{ this.pageDetails().return }}</p>
            </div>
        </div>
        <hr style="width: 90%; margin: auto; border: 1px solid #F5F7F8; opacity: 1; margin-top: 10px; margin-bottom: 20px;">
        <div (click)="this.openDocument(files.PRIVACY)" style="margin-top: 7px;">
            <div style="margin-top: 7px;">
                <img style="display: inline-block; width: 28px; height: 28px; margin-right: 10px;" src="/assets/images/documents/icon-legal.svg" alt="">
                <p style="display: inline-block; font-weight:500;">{{ this.pageDetails().privacy }}</p>
            </div>
        </div>
    </div>
</div>